import { Box } from '@mantine/core';

export default function AnchorBox() {
  return (
    <Box
      style={{
        marginLeft: 'auto',
        marginRight: 'auto',
        height: '3px',
        width: '0.375rem',
        borderRadius: '9999px',
        '--tw-bg-opacity': 1,
        backgroundColor: 'rgb(18 22 25 / var(--tw-bg-opacity))',
        '--tw-shadow':
          '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
        '--tw-shadow-colored':
          '0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)',
        boxShadow:
          'var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)',
      }}
    ></Box>
  );
}
